import React, { lazy, Suspense } from 'react'
import { MapPin, Plane, Car, Check } from 'lucide-react'
const Hero = lazy(() => import('./inner_components/Hero'))

const RentalPackages = () => {
  const packages = [
    {
      icon: <MapPin className="w-12 h-12 text-[#1865a5]" />,
      title: 'City Tours',
      description:
        "Experience the beauty and culture of the city with our tailored city tour packages. Whether you're a tourist or a resident, enjoy hassle-free travel to iconic landmarks, shopping spots, and more.",
      highlights: [
        'Flexible schedules',
        'Experienced drivers',
        'Affordable packages',
      ],
    },
    {
      icon: <Plane className="w-12 h-12 text-[#1865a5]" />,
      title: 'Airport Transfers',
      description:
        'Reliable and on-time airport transfer services to ensure your journey begins or ends stress-free. From solo travellers to corporate groups, we accommodate all.',
      highlights: [
        '24/7 availability',
        'Meet-and-greet services',
        'Real-time flight tracking',
      ],
    },
    {
      icon: <Car className="w-12 h-12 text-[#1865a5]" />,
      title: 'Outstation Cabs',
      description:
        'Plan your next getaway with our comfortable and safe outstation cab services. Choose from one-way or round-trip options and explore destinations without worrying about the journey.',
      highlights: [
        'Competitive pricing',
        'Experienced drivers',
        'Range of vehicles available',
      ],
    },
  ]

  return (
    <div className="min-h-screen bg-gray-50">
      <Suspense
        fallback={<div className="h-[35rem] bg-gray-200 animate-pulse" />}
      >
        {/* Hero Section */}
        <div data-aos="fade-down" data-aos-duration="500">
          <Hero
            tagline="Our Services"
            title="Rental Packages"
            description="Discover the perfect transportation solution for your needs"
            bgImage="/images/rental-package.jpg"
          />
        </div>
      </Suspense>

      {/* Packages Section */}
      <div
        className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16"
        data-aos="fade-up"
        data-aos-duration="700"
      >
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {packages.map((pkg, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-2xl transition-shadow duration-300 border-2 border-[#9fd4ff]"
              data-aos="zoom-in"
              data-aos-delay={index * 100}
              data-aos-duration="600"
            >
              {/* Icon Container */}
              <div className="h-20 w-20 mx-auto mt-6 relative overflow-hidden rounded-full bg-[#d4ebff] flex items-center justify-center border-2 border-[#377ab0] ">
                <div className="text- text-3xl">{pkg.icon}</div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3
                  className="text-2xl font-semibold mb-4 text-gray-900 text-center"
                  data-aos="fade-up"
                  data-aos-delay={index * 100 + 200}
                >
                  {pkg.title}
                </h3>
                <p
                  className="text-gray-600 mb-6 leading-relaxed text-center"
                  data-aos="fade-up"
                  data-aos-delay={index * 100 + 300}
                >
                  {pkg.description}
                </p>

                {/* Highlights */}
                <div
                  className="space-y-3"
                  data-aos="fade-up"
                  data-aos-delay={index * 100 + 400}
                >
                  <h4 className="text-lg font-semibold text-gray-900">
                    Highlights
                  </h4>
                  {pkg.highlights.map((highlight, hIndex) => (
                    <div key={hIndex} className="flex items-center space-x-2">
                      <Check className="w-5 h-5 text-green-500" />
                      <span className="text-gray-600">{highlight}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default RentalPackages
